import { render, staticRenderFns } from "./alarmsnew.vue?vue&type=template&id=05cb20e4&scoped=true&"
import script from "./alarmsnew.vue?vue&type=script&lang=js&"
export * from "./alarmsnew.vue?vue&type=script&lang=js&"
import style0 from "./alarmsnew.vue?vue&type=style&index=0&id=05cb20e4&lang=less&scoped=true&"
import style1 from "./alarmsnew.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05cb20e4",
  null
  
)

export default component.exports